export const vehicleType = [
    { code: 1, description: 'Car' },
    { code: 3, description: 'Truck' },
    { code: 4, description: 'Van' },
    { code: 5, description: 'SUV' },
    { code: 20, description: 'RV' },
    { code: 21, description: 'Motorcycle' },
    { code: 28, description: 'Marine' },
    { code: 38, description: 'Commercial Heavy Truck' },
    { code: 39, description: 'Commercial Medium Truck' },
    { code: 41, description: 'Other/Unknown Vehicle Type' }
];
/*
    21 for motorcycle or scooter,
    22 for ATV,
    32 for RUV,
    30 for Snowmobile,
    42 for LSV
*/
export const vehiclesEligibleForMCTagging = [21, 22, 32, 30, 42];
/**
 * Type IDs representing commercial generic vehicles (used in both vehicle and vehicleInfo domains).
 * Centralised here to avoid duplication between domain/vehicle and domain/vehicleInfo and circular dependencies
 */
export const COMMERCIAL_VEHICLE_TYPE_IDS = [38, 39, 40, 41, 103, 104];
//# sourceMappingURL=VehicleType.js.map